import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { messages } from './langs'

window.Vue = Vue

export default new VueI18n({
  locale: 'de', // set locale
  messages
})
